import { flash } from './flash.js'
import { t } from './i18n.js'
import router from '../router.js'

// Determine parent route from current path
function getParentRoute(path) {
  if (path.match(/^\/projects\/\d+/)) return { name: 'projects' }
  if (path.match(/^\/tasks\/\d+/)) return { name: 'tasks' }
  if (path.match(/^\/products\/\d+/)) return { name: 'products' }
  if (path.match(/^\/users\/\d+/)) return { name: 'users' }
  if (path.match(/^\/partners\/\d+/)) return { name: 'partners' }
  return { name: 'home' }
}

/**
 * Handle 403/404 API errors - show flash message and redirect to parent route
 * @param {Response} response - The fetch response object
 * @returns {Promise<boolean>} - true if error was handled (redirect occurred), false otherwise
 */
export async function handleApiError(response) {
  if (response.status === 403 || response.status === 404) {
    const data = await response.json()
    const fallbackKey = response.status === 404 ? 'vue.errors.record_not_found' : 'vue.errors.access_denied'
    flash(data.error || t(fallbackKey), 'alert')
    const parentRoute = getParentRoute(router.currentRoute.value.path)
    router.push(parentRoute)
    return true
  }
  return false
}
